<template>
    <div
        v-if="banner && !bannerHidden && !bannerClosed"
        class="header-notification"
        :class="`header-${banner.background}`"
    >
        <p v-html="banner.content"></p>
        <button @click="clickClose" v-if="banner.time !== 'full-time'">
            <SvgIcon name="close" />
        </button>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";

import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";

import { useCookieStorage } from "@/shared/composables/use-storage";

import { NotificationBanner } from "@/header/model/notification-banner";
import { getNotificationBanner } from "@/api/kentico-api";

const route = useRoute();

const { setItem: setCookie, getItem: getCookie } = useCookieStorage();

const banner = ref<NotificationBanner>(null);
const bannerClosed = ref(false);

const storageKey = computed(() => `notification-banner-${banner.value?.id}`);
const storageValue = "hide";

const bannerHidden = computed(() => {
    switch (banner.value?.time) {
        case "close-time": // Po zavření se již nikdy nezobrazí (Cookies)
            return getCookie(storageKey.value) === storageValue;
        case "seating-time": // Po přechodu na jinou stránku se již nezobrazí
        case "session": // Po zavření se už v rámci session nezobrazí (Cookies)
            return getCookie(storageKey.value) === storageValue;
        case "full-time": // Na pořád (Nejde zavřít)
        default:
            return false;
    }
});

let routeChanged = false;

watch(route, async () => {
    const response = await getNotificationBanner({ path: route.fullPath });
    if (response) {
        banner.value = response;

        routeChanged = true;

        if (banner.value?.time === "seating-time" && routeChanged)
            setCookie(storageKey.value, storageValue, "essential");
    }
});

const clickClose = () => {
    bannerClosed.value = true;

    switch (banner.value.time) {
        case "close-time": // Po zavření se již nikdy nezobrazí (Cookies)
            setCookie(storageKey.value, storageValue, "essential", { expires: Date.now() + 365 * 24 * 60 * 60 * 1000 });
            break;
        case "seating-time": // Po přechodu na jinou stránku se již nezobrazí
        case "session": // Po zavření se  už v rámci session nezobrazí (Cookies)
            setCookie(storageKey.value, storageValue, "essential");
            break;
        case "full-time": // Na pořád (Nejde zavřít)
        default:
            return;
    }
};
</script>
